const spAccordionArray = [...document.querySelectorAll('.js-sp-accordion-target')];


spAccordionArray.forEach((e) => {
  e.addEventListener('click', () => {
    e.parentElement.classList.toggle('is-open-accordion');
  })
})